import $ from "jquery";

var ellipsis =
  '<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>';

/**
 * Handle checkbox change for cart addon add/remove.
 *
 * @param {jQuery} $checkbox - The checkbox element
 * @param {Object} options
 * @param {Function} options.getLabelEl - Returns the jQuery label element for text updates
 * @param {Function} options.getAddingText - Returns text shown while adding
 * @param {Function} options.getAddedText - Returns text shown after added
 * @param {Function} options.getRemovingText - Returns text shown while removing
 * @param {Function} options.getRemovedText - Returns text shown after removed
 * @param {Object}  [options.removeData] - Extra fields for the remove AJAX payload
 */
export function handleCartToggle($checkbox, options) {
  var value = $checkbox.prop("checked") ? "add" : "remove";
  var productInfo = $checkbox.data("product-info");
  var $label = options.getLabelEl($checkbox);

  if (value === "add") {
    $label.html(options.getAddingText(productInfo) + ellipsis);
    var data = {
      action: "ql_woocommerce_ajax_add_to_cart",
      product_id: productInfo.product_id,
      product_type: "addon",
      quantity: 1,
    };
    $(document.body).trigger("adding_to_cart", [$checkbox, data]);

    $.ajax({
      type: "post",
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      success: function (response) {
        if (response.cart_total) {
          $(".price-total").html(response.cart_total);
        }
        if (response.fragments && response.fragments.cart_total) {
          $(".price-total").html(response.fragments.cart_total);
        }
        $("#" + $checkbox.attr("id") + "_text").html("Added");
        $label.text(options.getAddedText(productInfo));
        if (response.error && response.product_url) {
          window.location = response.product_url;
        } else {
          $(document.body).trigger("added_to_cart", [
            response.fragments,
            response.cart_hash,
            $checkbox,
          ]);
        }
      },
    });
  } else {
    $label.html(options.getRemovingText(productInfo) + ellipsis);
    var removeData = {
      action: "ql_woocommerce_ajax_remove_from_cart",
      product_id: productInfo.product_id,
    };
    if (options.removeData) {
      $.extend(removeData, options.removeData);
    }

    $.ajax({
      type: "post",
      url: wc_add_to_cart_params.ajax_url,
      data: removeData,
      success: function (response) {
        if (response.cart_total) {
          $(".price-total").html(response.cart_total);
        }
        if (response.fragments && response.fragments.cart_total) {
          $(".price-total").html(response.fragments.cart_total);
        }
        $label.text(options.getRemovedText(productInfo));
        if (response.error && response.product_url) {
          window.location = response.product_url;
        } else {
          $(document.body).trigger("removed_from_cart", [
            response.fragments,
            response.cart_hash,
            $checkbox,
          ]);
        }
      },
    });
  }
}

/**
 * Refresh cart fragments in the DOM.
 * Fades out elements, replaces with new content, triggers event.
 *
 * @param {Object} fragments - Map of selector -> HTML
 * @param {string} triggerEvent - Event name to fire after refresh
 */
export function refreshFragments(fragments, triggerEvent) {
  if (fragments) {
    $.each(fragments, function (key) {
      $(key)
        .addClass("updating")
        .fadeTo("400", "0.6")
        .block({
          message: null,
          overlayCSS: { opacity: 0.6 },
        });
    });

    $.each(fragments, function (key, value) {
      $(key).replaceWith(value);
      $(key).stop(true).css("opacity", "1").unblock();
    });

    $(document.body).trigger(triggerEvent);
  }
}
